(ns io.daskul.tutorial.webapp.domain.bootstrap.subs
  "Boot/readiness subscriptions (SMS-70).

   ::phase composes the pure io.daskul.webapp.bootstrap/phase predicate over the
   current db substate so the shell can gate render on a single value."
  (:require
   [re-frame.core :as rf]
   [io.daskul.webapp.bootstrap :as bootstrap]
   [io.daskul.tutorial.webapp.domain.auth.subs :as auth.subs]))

;; ::bootstrap has fired (boot started).
(rf/reg-sub
 ::started?
 (fn [db _]
   (boolean (get-in db [:bootstrap :started?]))))

;; Config readiness substate: {:loaded? bool :error any}.
(rf/reg-sub
 ::config
 (fn [db _]
   (select-keys (:config db) [:loaded? :error])))

;; True once the flag fetch has resolved either way (success OR failure).
;; Derived — NOT true before ::bootstrap has fired (which sets :loading? true).
;; A flag error settles too, so it never blocks the boot (fail-safe).
(rf/reg-sub
 ::flags-settled?
 (fn [db _]
   (let [ff (:feature-flags db)]
     (boolean
      (and (false? (:loading? ff))
           (or (some? (:flags ff)) (some? (:error ff))))))))

;; Readiness phase: :idle → :loading → :ready, or :error on hard-required failure.
;; Pure logic lives in io.daskul.webapp.bootstrap/phase (node-unit-tested seam).
(rf/reg-sub
 ::phase
 :<- [::started?]
 :<- [::auth.subs/authenticated?]
 :<- [::config]
 :<- [::flags-settled?]
 (fn [[started? authed? config flags-settled?] _]
   (bootstrap/phase {:started? started?
                     :authed?  authed?
                     :config   config
                     :flags    {:settled? flags-settled?}})))
